import { CustomMetaTitle } from 'Components';
import { ExpenseClaimContextProvider } from 'Context/ExpenseClaimContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ExpenseClaimMain } from './ExpenseClaimMain';

interface IExpenseClaim {
  nextStep: () => void;
}

export const ExpenseClaim = ({ nextStep }: IExpenseClaim) => {
  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.ExpenseClaim].pageTitle} />
      <ExpenseClaimContextProvider>
        <ExpenseClaimMain nextStep={nextStep} />
      </ExpenseClaimContextProvider>
    </>
  );
};
